import React from 'react';
import classNames from 'classnames';

import './TableWithAsideLayout.scss';

import { SvgCross, TertiaryBtn } from '@tmapy/style-guide';

import { PageTitle } from '../../app/components/PageTitle';

type TableWithAsideLayoutProps = {
  asideLabel: string;
  isAsideOpen: boolean;
  onAsideClose(): void;
  children: React.ReactNode;
};

export const TableWithAsideLayout: React.FC<TableWithAsideLayoutProps> = ({
  isAsideOpen,
  asideLabel,
  onAsideClose,
  children,
}) => (
  <div
    className={classNames({
      'dmx-tableWithAsideLayout': true,
      'dmx-tableWithAsideLayout-asideOpen': isAsideOpen,
    })}
  >
    <div>{React.Children.toArray(children)[0]}</div>
    {isAsideOpen && (
      <aside className='dmx-tableWithAsideLayout--aside sg-u-vs-4 sg-a-pt-4 sg-a-pl-4 sg-a-pr-4'>
        <div className='sg-a-d-f sg-a-jc-sb sg-a-ai-c'>
          <PageTitle>{asideLabel}</PageTitle>
          <TertiaryBtn icon={{ element: <SvgCross /> }} onClick={onAsideClose} />
        </div>
        {React.Children.toArray(children)[1]}
      </aside>
    )}
  </div>
);
